import React from "react";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";

function BloqueInfoAudit({ modulesBloqueInfo }) {
  return (
    <>
      <div id="bloque-noticia" className="d-flex flex-nowrap">
        <section>
          {/* Para cambiar de lado en el div se agrega bloque-izquierda */}
          <div
            className={`card-map ${
              modulesBloqueInfo.alignment === "align-right"
                ? "bloque-info-derecha"
                : "bloque-izquierda"
            }`}
          >
            <picture>
              <img
                src={
                  modulesBloqueInfo.image_desktop
                    ? modulesBloqueInfo.image_desktop[0]?.url
                    : ""
                }
                alt={
                  modulesBloqueInfo.image_desktop
                    ? modulesBloqueInfo.image_desktop[0]?.alt
                    : modulesBloqueInfo?.title_content
                }
                title={modulesBloqueInfo?.title_content}
                className="img-card-noticia"
              />
            </picture>
          </div>{" "}
        </section>
        {/* </WhereToBuyContext.Provider> */}
        {/* Para cambiar de lado en el section se agrega bloque-info-derecha */}
        <section
          id="institucional__dondecomprar"
          className={`container display-bloque ${
            modulesBloqueInfo.alignment === "align-right"
              ? "bloque-izquierda"
              : "bloque-info-derecha"
          }`}
        >
          <div className="grid-bloque">
            <div className="style-donde-comprar-izquierda">
              <article className="info-card">
                <h1>{modulesBloqueInfo.title_content}</h1>

                <div
                  dangerouslySetInnerHTML={{
                    __html: modulesBloqueInfo.content,
                  }}
                ></div>
                {modulesBloqueInfo?.seeMoreLink ? (
                  <div className="pt-3">
                    <a
                      className="settings_button-border button-b-primary_2 posicion-boton"
                      href={`${modulesBloqueInfo.seeMoreLink}`}
                    >
                      Ver Más <ArrowForwardOutlinedIcon />
                    </a>
                  </div>
                ) : null}
              </article>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default BloqueInfoAudit;
